import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import SimpleImageCarousel from '@homeaway/react-simple-image-carousel';
import {pushEdapEvent} from '../../../utils/edap';
import {SVGIcon} from '@homeaway/react-svg';

const SVG_SERP_CHEVRON_LEFT__24 =
    '<svg data-id="SVG_SERP_CHEVRON_LEFT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" d="M16 23L5 12 16 1"></path></svg>';
const SVG_SERP_CHEVRON_RIGHT__24 =
    '<svg data-id="SVG_SERP_CHEVRON_RIGHT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" d="M8 23l11-11L8 1"></path></svg>';

function sendToEdap(direction) {
    const eventData = {
        actionlocation: 'properties-module',
        eventcategory: 'photo-album-arrow-click',
        eventaction: `${direction}-arrow-clicked`,
    };
    pushEdapEvent('generic.event', eventData);
}

export function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export class ImageCardComponent extends PureComponent {
    constructor() {
        super();
        this.state = {
            currentIndex: 0,
        };
    }

    onImageNavigate = (currentIndex, direction) => {
        this.setState({currentIndex});
        sendToEdap(direction);
    };

    onImageNavigateLeft = (index) => {
        this.onImageNavigate(index, 'left');
    };

    onImageNavigateRight = (index) => {
        this.onImageNavigate(index, 'right');
    };

    getCarouselImages(images) {
        const {propertyName, isMobile, isTablet} = this.props;
        let carouselImages = [{src: images[0], altText: propertyName}];

        if (!(isMobile || isTablet)) {
            carouselImages = [
                ...carouselImages,
                {src: images[1], altText: propertyName},
                {src: images[2], altText: propertyName},
            ];
        }

        return carouselImages;
    }

    renderButtons({setPrevRef, setNextRef}) {
        return [
            <button
                key="0"
                className="SimpleImageCarousel__button SimpleImageCarousel__button--left"
                data-wdio="SimpleImageCarousel__button--prev"
                ref={setPrevRef}
            >
                <span className="sr-only">{'Previous Image'}</span>
                <SVGIcon
                    className="SimpleImageCarousel__svg SimpleImageCarousel__svg--left"
                    markup={SVG_SERP_CHEVRON_LEFT__24}
                />
            </button>,
            <button
                key="1"
                className="SimpleImageCarousel__button SimpleImageCarousel__button--right"
                data-wdio="SimpleImageCarousel__button--next"
                ref={setNextRef}
            >
                <span className="sr-only">{'Next Image'}</span>
                <SVGIcon
                    className="SimpleImageCarousel__svg SimpleImageCarousel__svg--right"
                    markup={SVG_SERP_CHEVRON_RIGHT__24}
                />
            </button>,
        ];
    }

    render() {
        const {onClick, images, listingUri, target} = this.props;
        const {currentIndex} = this.state;

        return (
            <SimpleImageCarousel
                images={this.getCarouselImages(images)}
                onNextClick={this.onImageNavigateRight}
                onPrevClick={this.onImageNavigateLeft}
                index={currentIndex}
                tabIndex={-1}
                onClick={onClick}
                renderButtons={this.renderButtons}
                href={listingUri}
                target={target}
            />
        );
    }
}

export function mapStateToProps(state) {
    return {
        isMobile: state.config.isMobile,
        isTablet: state.config.isTablet,
    };
}

export const ImageCard = connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageCardComponent);

ImageCard.displayName = 'ImageCard';

export default ImageCard;
